<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.subordinategradestructure')"
        :col="3"
      >
        <div class="row">
          <div class="ml-4 mr-2">
            <button class="btn btn-success" @click="oeffneTBDModal">
              <font-awesome-icon icon="fa-regular fa-plus" />
              {{ $t("global.new") }}
            </button>
          </div>
          <div class="mr-2">
            <button class="btn btn-primary">
              <font-awesome-icon icon="fa-duotone fa-print" class="mr-2" />
              {{ $t("global.output") }}
            </button>
          </div>
          <div class="mr-2">
            <b-dropdown variant="primary">
              <template slot="button-content">
                <font-awesome-icon icon="fa-regular fa-cog" class="mr-2" />
                <em class="mr-2">{{ $t("global.actions") }}</em>
              </template>
              <b-dropdown-item class="col-4">
                <font-awesome-icon icon="fa-duotone fa-trash" class="mr-2" />
                {{ $t("global.delete") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :items="notenstrukturliste"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :busy="isBusy"
              show-empty
              sort-icon-left
              fixed
              selectable
              select-mode="range"
              @row-dblclicked="details"
              thead-tr-class="pointer"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/Api";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";
import reiter from "@/mixins/Reiter";

export default {
  components: {
    ContainerHeadline,
    BSpinner,
  },
  mixins: [reiter],
  props: {
    notenstruktur: {
      type: String,
      required: true,
    },
    shown: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      page: 0,
      infiniteId: +new Date(),
      anzahlProPage: 50,
      notenstrukturliste: [],
      sortBy: "kuerzel",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      selected: [],
      selectedIds: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "kuerzel",
          sortable: true,
          label: this.$t("global.shortdesignation"),
        },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
        },
        {
          key: "parentStruktur",
          sortable: true,
          label: this.$t("global.path"),
        },
        {
          key: "gueltig_ab",
          sortable: true,
          label: this.$t("global.validfrom"),
        },
        {
          key: "notenstrukturstatus.bezeichnung",
          sortable: true,
          label: this.$t("global.status"),
        },
        {
          key: "gewichtung",
          sortable: true,
          label: this.$t("global.weighting"),
        },
        { key: "rundung", sortable: true, label: this.$t("global.rounding") },
      ];
    },
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      if (this.suche) params.suche = this.suche;

      return params;
    },
  },
  created() {},
  mounted() {
    if (this.shown && this.notenstrukturliste.length == 0)
      this.getNotenstrukturliste();
  },
  watch: {
    shown(val) {
      if (val && this.notenstrukturliste.length == 0)
        this.getNotenstrukturliste();
    },
  },
  methods: {
    getNotenstrukturliste() {
      this.isBusy = true;

      Api.get("notenstruktur/", {
        params: { parent: this.notenstruktur },
      })
        .then((response) => {
          this.notenstrukturliste = response.data;
          response.data.forEach((v) => {
            v.parentStruktur = v.kuerzel;
            if (v.parent_notenstruktur) {
              v.parentStruktur =
                v.parentStruktur + " / " + v.parent_notenstruktur.kuerzel;
              if (v.parent_notenstruktur.parent_notenstruktur) {
                v.parentStruktur =
                  v.parentStruktur +
                  " / " +
                  v.parent_notenstruktur.parent_notenstruktur.kuerzel;
              }
            }
          });
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    details() {},
    schliesseZuordnenModal() {},
    KlassenPeriodenZuordnen() {},
    oeffneTBDModal() {},
    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = true;
          if (!this.selectedIds.includes(gp.id)) {
            this.selectedIds.push(gp.id);
          }
        });
      } else {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },
    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
      }
    },
    /*
    oeffneKlassePeriodeZuordnenModal() {
      $("#modal-klassen-perioden-zuordnen").modal("show");
    },
    schliesseZuordnenModal() {
      $("#modal-klassen-perioden-zuordnen").modal("hide");
    },
    KlassenPeriodenZuordnen() {},
    */
  },
};
</script>
